export class LoadCicdRepositories {
    static type = '[CICD] LoadCicdRepositories'
    constructor() { }
}

export class LoadDataTableCicdRepositories {
    static type = '[CICD] LoadDataTableCicdRepositories'
    constructor() { }
}

export class UpdateCountersCicdRepositories {
    static type = '[CICD] UpdateCountersCicdRepositories'
    constructor() { }
}

export class ClearCicdRepository {
    static type = '[CICD] ClearCicdRepository'
    constructor() { }
}

export class SetCicdRepository {
    static type = '[CICD] SetCicdRepository'
    constructor(public cicd_repository_id: any) { }
}

export class LoadCicdRepositoriesCharts {
    static type = '[CICD] LoadCicdRepositoriesCharts'
    constructor() { }
}

export class LoadCicdRepositoriesChartsFilteredData {
    static type = '[CICD] LoadCicdRepositoriesChartsFilteredData'
    constructor() { }
}
